<template>
  <div class="PlainSideBar" id="scroll">
    <ExpertProfile v-if="$router.currentRoute.name == 'expertStore'"></ExpertProfile>

    <UserProfile v-else></UserProfile>
  </div>
</template>

<script>
import UserProfile from "@/components/UserProfile.vue";
import ExpertProfile from "@/components/ExpertProfile.vue";

export default {
  name: "PlainSideBar",

  components:{
    UserProfile,
    ExpertProfile
  },
};
</script>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.PlainSideBar {
  width: 265px;
  -webkit-box-shadow: 10px 0 10px -5px #d3d3d3;
  box-shadow: 10px 0 10px -5px #d3d3d3;
  position: fixed;
  height: 100%;
  overflow: auto;
  background-color: $filter-section-background-color;
  z-index: 3;
}
</style>
